import React, { useEffect, useState } from 'react';
import { Breadcrumb } from 'antd';
import './index.scss';
import { isNullObject } from '@/utils';

export type BreadConfig = {
  label: string;
  key: string | number;
  onClick: AnyFunc;
};

type Props = {
  config: BreadConfig[];
};

const CommonBreadCrumb = (props: Props) => {
  const { config } = props;
  return (
    <div className='common-breadcrumb'>
      <Breadcrumb separator='>'>
        {!isNullObject(config) &&
          config.map((item: BreadConfig) => {
            return (
              <Breadcrumb.Item
                key={item.key}
                onClick={item.onClick}
                className='common-bread-item'
              >
                {item.label}
              </Breadcrumb.Item>
            );
          })}
      </Breadcrumb>
    </div>
  );
};
export default React.memo(CommonBreadCrumb);
